import { assertNever } from "@@/shared/assert-never";
import type { LanguageCode } from "@@/shared/translations/language-code";
import type { Locale } from "date-fns";
import {
    de as deLocale,
    enGB as enLocale,
    sv as svLocale,
} from "date-fns/locale";

const getLocaleFromLanguageCode = (languageCode: LanguageCode): Locale => {
    if (languageCode === "de") return deLocale;
    if (languageCode === "en") return enLocale;
    if (languageCode === "sv") return svLocale;
    assertNever(languageCode);
};

export { getLocaleFromLanguageCode };
